export const style = {
  th: {
    borderBottom: `1px solid #666`
  },
  tr: {
    cursor: `pointer`,
    ':hover': {
      background: `#f5f5f5`
    }
  },
  td: {
    borderTop: `1px solid #666`
  }
}

export default style



// WEBPACK FOOTER //
// ./src/components/Settings/partials/SettingsEditor/style/ColorBlind/table.js